<template>
    <div class="rel">
        <p style="display:flex;justify-content:end;margin-bottom:10px">
            <el-popover placement="right" :width="250" v-model:visible="visible2" popper-class="plusResumePop"
                        v-show="!newResumeStatus && baseInfoList.length<5" v-has-permi="['resume:info:add']">
                <el-form label-width="80px">
                    <el-form-item label="简历名称" required>
                        <el-input size="small" v-model="newResumeName"></el-input>
                    </el-form-item>
                </el-form>
                <div style="text-align:right;margin:0">
                    <el-button size="mini" type="text" @click="visible2 = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="addTab(newResumeName)">确定</el-button>
                </div>
                <template #reference>
                    <el-button icon="el-icon-plus" @click="visible2 = true; newResumeName=''">添加
                    </el-button>
                </template>
            </el-popover>
            <el-popover placement="right" :width="250" v-model:visible="autoAddVisible" popper-class="plusResumePop"
                        v-show="!newResumeStatus && baseInfoList.length<5" v-has-permi="['resume:info:auto']">
                <div class="auto_tip">平台将根据您的数据为您生成智能简历~</div>
                <el-form label-width="80px">
                    <el-form-item label="简历名称" required>
                        <el-input size="small" v-model="newResumeName"></el-input>
                    </el-form-item>
                </el-form>
                <div style="text-align:right;margin:0">
                    <el-button size="mini" type="text" @click="autoAddVisible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="autoAddTab(newResumeName)">确定</el-button>
                </div>
                <template #reference>
                    <el-button icon="el-icon-plus" @click="openAutoAddDialog">自动生成简历
                    </el-button>
                </template>
            </el-popover>
        </p>
        <el-tabs class="resumeTabs" type="card" v-model="editableTabsValue">
            <el-tab-pane v-for="(item, index) in baseInfoList" :key="index">
                <span slot="label">
                        <span v-if="resumeNameEditStatus==true && nameEditStatus.id==item.id">
                            <el-input class="resumeNameInput" :ref="`item.id`" v-model="item.resumeName"
                                      @blur="resumeNameBlur" @keyup.enter.native="resumeNameBlur"
                                      @change="updateResumeName(item.id, item.resumeName)"
                                      maxlength="6"
                                      placeholder="请填写"
                                      style="width:115px">
                            </el-input>
                        </span>
                        <span class="resumeName" v-else>{{item.resumeName}}</span>
                    <!--<i class="el-icon-edit-outline"></i>-->
                    <!--<i class="el-icon-delete"></i>-->
                    <span class="rEditIcons">
                        <el-button size="mini" type="text" icon="el-icon-edit-outline"
                                   @click="editResumeName(item.id)" v-has-permi="['resume:info:resumeName']"></el-button>
                        <!--<el-popover-->
                        <!--placement="top-start"-->
                        <!--title="确定删除？"-->
                        <!--width="100"-->
                        <!--trigger="click">-->
                        <!--<div>-->
                        <!--<el-button type="mini" @click="deleteResume(item.id)">确认</el-button>-->
                        <!--</div>-->
                        <!--<el-button slot="reference" size="mini" type="text" icon="el-icon-delete"></el-button>-->
                        <!--</el-popover>-->
                        <el-popconfirm
                                title="确定删除？"
                                @confirm="deleteResume(item.id)"
                                placement="top-start"
                                icon-color="red"
                                v-has-permi="['resume:info:delete']">
                            <el-button slot="reference" size="mini" type="text" icon="el-icon-delete"></el-button>
                        </el-popconfirm>
                    </span>
                </span>
                <!--简历状态栏-->
                <status-bar :baseInfo="item"></status-bar>
                <!--简历基本信息-->
                <base-info :baseInfo="item"></base-info>
                <!--简历关键词-->
                <resume-keyword :resume-info="item"></resume-keyword>
                <!--工作经历-->
                <work-experience :resumeInfo="item"></work-experience>
                <!--项目经历-->
                <project-experience :resumeInfo="item"></project-experience>
                <!--竞赛经历-->
                <competition-experience :resumeInfo="item"></competition-experience>
                <!--教育经历-->
                <education-experience :resumeInfo="item"></education-experience>
                <!--培训经历-->
                <training-experience :resumeInfo="item"></training-experience>
                <!--<professional :resumeInfo="item"></professional>-->
                <!--技能-->
                <skill :resumeInfo="item"></skill>
                <!--语言-->
                <language :resumeInfo="item"></language>
                <!--证书-->
                <cert :resumeInfo="item"></cert>
                <!--附件-->
                <attachment :resumeInfo="item"></attachment>
            </el-tab-pane>

            <el-tab-pane v-if="newResumeStatus" name="newResume">
                <span slot="label">
                    <el-input v-model="newResumeName" @change="saveNewResumeName" placeholder="请填写简历名称" maxlength="6"
                              style="width:130px"></el-input>
                </span>
                <status-bar :baseInfo="form" v-on:updateStatus="updateNewResumeStatus"></status-bar>
                <br/>
                <br/>
                <base-info-form :form="form" :editStatus="editStatus" :newResumeFlag="true"></base-info-form>
            </el-tab-pane>

            <!--<el-tab-pane name="addResuem">-->
            <!--<span slot="label">-->
            <!--<i class="el-icon-circle-plus-outline"></i>-->
            <!--新增简历-->
            <!--</span>-->
            <!--</el-tab-pane>-->

        </el-tabs>
    </div>
</template>
<script>
    import BaseInfo from './BaseInfo.vue';
    import BaseInfoForm from './Form/BaseInfoForm.vue';
    import StatusBar from './StatusBar.vue';
    import ResumeKeyword from './ResumeKeyword';
    import Contact from './Contact.vue';
    import WorkExperience from './WorkExperience.vue';
    import ProjectExperience from './ProjectExperience.vue';
    import CompetitionExperience from './CompetitionExperience.vue';
    import EducationExperience from './EducationExperience.vue';
    import TrainingExperience from './TrainingExperience.vue';
    import Professional from './Professional.vue';
    import Skill from './Skill.vue';
    import Language from './Language.vue';
    import Cert from './Cert.vue';
    import Attachment from './Attachment.vue';
    import {autoGenerateBaseInfo, deleteResumeBaseInfo, updateResumeName} from '@/api/resume';

    const GRADUATIONWORK = 1;   // 毕业找工作
    export default {
        data() {
            return {
                visible: false,
                // 新增简历填写简历名称弹窗显示状态
                visible2: false,
                autoAddVisible: false,
                form: {
                    publicStatus: false,
                    jobStatus: GRADUATIONWORK,
                    expectPosition: [],
                },
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                // 简历名称编辑状态
                nameEditStatus: {
                    id: 0,
                    status: false,
                },
                // 新建简历名称
                newResumeName: '',
                editableTabsValue: '',
            };
        },
        created() {
            this.getBaseInfoListByCreatorId();
        },
        computed: {
            // 个人简历列表
            baseInfoList() {
                return this.$store.state.userCenter.baseInfoList;
            },
            // 简历刷新标记
            resumeRefreshFlag() {
                return this.$store.state.index.resumeRefreshFlag;
            },
            // 简历名称编辑状态
            resumeNameEditStatus() {
                return this.$store.state.index.resumeNameEditStatus;
            },
            // 新建简历表单显示状态
            newResumeStatus() {
                return this.$store.state.index.newResumeStatus;
            },
            // 需要修改新建简历表单显示状态为true的标记
            updateNewResumeStatusFlag() {
                return this.$store.state.index.updateNewResumeStatusFlag;
            }

        },
        watch: {
            // 监听简历是否需要刷新
            resumeRefreshFlag(newVal, oldVal) {
                if (newVal == true) {
                    this.getBaseInfoListByCreatorId();
                }
                this.$store.commit('changeResumeRefreshFlag', false);
            }
        },
        methods: {
            updateNewResumeStatus(status) {
                this.form.publicStatus = status.publicStatus;
                this.form.jobStatus = status.jobStatus;
            },
            addTab(targetName) {
                if (!this.checkDuplicate() && this.validateResumeName(this.newResumeName)) {
                    this.visible2 = false;
                    this.$store.commit('changeNewResumeStatus', true);
                    this.$store.commit('changeResumeEditStatus', true)
                    this.editableTabsValue = "newResume";
                    this.form = {
                        publicStatus: false,
                        jobStatus: GRADUATIONWORK,
                        expectPosition: [],
                    };
                    this.form.resumeName = this.newResumeName;
                    return false;
                }
            },
            /** 打开自动生成简历弹窗 */
            openAutoAddDialog() {
                this.autoAddVisible = true;
                this.newResumeName = '';
            },
            /** 自动生成简历 */
            autoAddTab() {
                if (!this.checkDuplicate() && this.validateResumeName(this.newResumeName)) {
                    this.autoAddVisible = false;
                    autoGenerateBaseInfo(this.newResumeName).then((res) => {
                        if(res.data){
                            this.getBaseInfoListByCreatorId();
                        }else{
                            this.addTab(this.newResumeName);
                        }
                    });
                    return false;
                }
            },
            checkDuplicate() {
                let isDuplicate = false;
                for (let i in this.baseInfoList) {
                    // 格式化简历基础信息
                    if (this.baseInfoList[i].resumeName === this.newResumeName) {
                        this.$message.error("简历名称已存在");
                        isDuplicate = true;
                        break;
                    }
                }
                return isDuplicate;
            },
//            beforeLeave(activeIndex,oldActiveIndex) {
//                if (activeIndex==="addResuem"){
//                    this.$store.commit('changeNewResumeStatus', true);
//                    this.editableTabsValue = "newResume";
//                    this.form = {};
//                    return false;
//                }
//            },
            // 获取当前用户简历基础信息列表
            getBaseInfoListByCreatorId() {
                this.$store.commit('changeNewResumeStatus', false);
                this.$store.dispatch("userCenter/getBaseInfoList").then(res => {
                    if (this.baseInfoList.length === 0) {
                        this.openAutoAddDialog();
                        // this.$store.commit('changeNewResumeStatus', true);
                        // this.$store.commit('changeResumeEditStatus', true)
                        // this.editableTabsValue = "newResume";
                        // this.form = {
                        //     publicStatus: false,
                        //     jobStatus: GRADUATIONWORK,
                        //     expectPosition: [],
                        // };
                        // this.newResumeName = '简历';
                        // this.form.resumeName = this.newResumeName;
                    } else {
                        if (this.updateNewResumeStatusFlag === true) {
                            this.$store.commit('changeNewResumeStatus', true);
                            this.$store.commit('changeUpdateNewResumeStatusFlag', false);
                        }
                        if (this.newResumeStatus && this.newResumeStatus === true) {
                            this.editableTabsValue = (this.baseInfoList.length - 1).toString();
                            this.$store.commit('changeNewResumeStatus', false);
                        }
                    }
                });
            },
            // 删除简历
            deleteResume(id) {
                deleteResumeBaseInfo(id).then(res => {
                    this.$store.commit('changeResumeRefreshFlag', true);

                    this.editableTabsValue = (this.editableTabsValue - 1).toString();
                    if (this.editableTabsValue < 0) {
                        if (this.baseInfoList.length === 0) {
                            this.editableTabsValue = "newResume";
                        } else {
                            this.editableTabsValue = "0";
                        }

                    }
                })
            },
            // 修改简历名称
            updateResumeName(id, resumeName) {
                if (this.validateResumeName(resumeName)) {
                    updateResumeName(id, resumeName).then(res => {
                        this.$store.commit('changeResumeRefreshFlag', true);
                        this.$store.commit('changeResumeNameEditStatus', false);
                        this.$message.success("保存成功");
                    })
                }
            },
            resumeNameBlur() {
                this.$store.commit('changeResumeNameEditStatus', false);
            },
            // 保存简历名称，将简历名称保存到form表单中
            saveNewResumeName() {
                for (let i in this.baseInfoList) {
                    // 格式化简历基础信息
                    if (this.baseInfoList[i].resumeName === this.newResumeName) {
                        this.$message.error("简历名称已存在");
                        return false;
                    }
                }
                if (this.validateResumeName(this.newResumeName)) {
                    this.form.resumeName = this.newResumeName;
                    this.$message.success("保存成功");
                }
            },
            // 简历名称进入编辑状态
            editResumeName(id) {
                // this.$refs['resumeName'].focus();
                //设置input获取焦点
                setTimeout(function () {
                    document.querySelector('.resumeNameInput input').focus()
                }, 100)
                this.nameEditStatus.id = id;
                this.$store.commit('changeResumeNameEditStatus', true);
                this.$message.info("编辑简历名称，回车即可保存");
            },
            // 校验简历名称
            validateResumeName(resumeName) {
                if (!resumeName) {
                    this.$message.error("简历名称不可为空");
                    return false;
                } else if (!/^\S+$/.test(resumeName)) {
                    this.$message.error("仅支持中英文、数值和特殊字符");
                    return false;
                }
                return true;
            }

        },
        components: {
            StatusBar,
            BaseInfo,
            BaseInfoForm,
            ResumeKeyword,
            Contact,
            WorkExperience,
            ProjectExperience,
            CompetitionExperience,
            EducationExperience,
            TrainingExperience,
            Professional,
            Skill,
            Language,
            Cert,
            Attachment,
        }
    };
</script>